'use client';

import React, { useEffect, useRef, useState } from 'react';
import { captureError } from '@/services/error-sender';
import styles from './auto-reload.module.scss';

const CHECK_UPDATES_TIMEOUT = 1 * 60 * 1000;
const CHECK_IS_STILL_UPDATING_TIMEOUT = 15 * 1000;
const getHash = () => fetch('/sys/site-version/').then((res) => res.text()).catch((e) => {
  captureError(e, ['auto-reload']);
  return '';
});

const AutoReload = () => {
  const initialHash = useRef('');
  const currentHash = useRef('');
  const [isUserNeedsToReload, setIsUserNeedsToReload] = useState(false);

  useEffect(() => {
    const checkUpdatesInterval = setInterval(async () => {
      currentHash.current = await getHash();

      if (initialHash.current === currentHash.current || !currentHash.current) return;

      /**
       * Проект деплоїться частинами і тому під час деплою хеш буде змінюватись декілька разів.
       * Щоб позбавити юзера від необхідності по декілька разів оновлювати сайт ми робимо другий
       * setInterval і якщо за CHECK_IS_STILL_UPDATING_TIMEOUT хеш не змінюється, то робимо висновок
       * що деплой завершено і просимо юзера оновити сторінку
       */
      const checkIsUpdatesFinishedInterval = setInterval(async () => {
        const hash = await getHash();

        if (hash === currentHash.current) {
          clearInterval(checkIsUpdatesFinishedInterval);
          clearInterval(checkUpdatesInterval);

          setIsUserNeedsToReload(true);
        } else currentHash.current = hash;
      }, CHECK_IS_STILL_UPDATING_TIMEOUT);
    }, CHECK_UPDATES_TIMEOUT);

    getHash().then((hash) => {
      initialHash.current = hash;
      currentHash.current = hash;
    });

    return () => {
      clearTimeout(checkUpdatesInterval);
    };
  }, []);

  if (!isUserNeedsToReload) return null;

  return (
    <div className={styles['auto-reload']}>
      <span>allrightpro.com has a new version.</span>
      <button type="button" className={styles.button} onClick={() => window.location.reload()}>Click to reload</button>
    </div>
  );
};

export default AutoReload;
